export default __webpack_public_path__ + "static/media/Indicator.0ce41aa4.jpg";